export const WEB_URL = {
  EXTERNAL_VENDOR_LOGIN: `external-vendor/login`,
}
